import { TREQUEST_ORDER_CHECKLIST_LISTING, TRESPONSE_ORDER_CHECKLIST_LISTING, TFilterSelected } from '@monorepo/types';
import { TFilterGroupModel, TUserPaginationOption } from '@monorepo/ui';
import { Action } from '@ngrx/store';
import { TOrderChecklistActionType } from './order-checklist.models';

export class GetOrderChecklist implements Action {
  readonly type = TOrderChecklistActionType.GetOrderChecklist;
  constructor(public payload: TREQUEST_ORDER_CHECKLIST_LISTING) {}
}

export class GetOrderChecklistSuccess implements Action {
  readonly type = TOrderChecklistActionType.GetOrderChecklistSuccess;
  constructor(public orderChecklistRes: TRESPONSE_ORDER_CHECKLIST_LISTING) {}
}

export class GetOrderChecklistFailure implements Action {
  readonly type = TOrderChecklistActionType.GetOrderChecklistFailure;
  constructor() {}
}

export class SetUserPaginationOption implements Action {
  readonly type = TOrderChecklistActionType.SetUserPaginationOption;
  constructor(public userPaginationOption: TUserPaginationOption) {}
}

export class SetOrderChecklistSelectedFilters implements Action {
  readonly type = TOrderChecklistActionType.SetOrderChecklistSelectedFilters;
  constructor(public filterModel: TFilterGroupModel<TFilterSelected>) {}
}

export class RefreshOrderChecklist implements Action {
  readonly type = TOrderChecklistActionType.RefreshOrderChecklist;
  constructor() {}
}

export type TOrderChecklistActions =
  | GetOrderChecklist
  | GetOrderChecklistSuccess
  | GetOrderChecklistFailure
  | SetUserPaginationOption
  | SetOrderChecklistSelectedFilters
  | RefreshOrderChecklist;
